import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { screenshotResourceLoadingClass } from "healthex-common/screenshot.dtos";
import { FlexColumn } from "./common.styles";
export const ScreenshotReadinessDetector = ({ isScreenshotMode, children }) => {
    const [isPageLoading, setIsPageLoading] = React.useState(isScreenshotMode !== null && isScreenshotMode !== void 0 ? isScreenshotMode : false);
    React.useLayoutEffect(() => {
        if (isScreenshotMode && isPageLoading) {
            setIsPageLoading(false);
        }
    }, [isScreenshotMode, isPageLoading]);
    return (_jsx(FlexColumn, { className: isPageLoading ? screenshotResourceLoadingClass : "", grow: true, style: { overflow: isScreenshotMode ? "visible" : "auto" }, children: children }));
};
ScreenshotReadinessDetector.displayName = "ScreenshotReadinessDetector";
